import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";
import Otp from "./OtpPopUp";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import { ChangePasswordStart, apiError, registerUserReset, userForgetPassword, verifyOtpErrorReset } from "../../store/actions";
import * as Yup from "yup";
import { useFormik } from "formik";
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo.svg";
import ForgetPassOtp from "./ForgetPassOtp";
import { toast } from "react-toastify";

const ForgetPasswordPage = (props) => {

  document.title = "Forget Password | Wwings - React Admin & Dashboard";

  const [showPass, setShowPass] = useState(false)
  const [inputLength, setInputLength] = useState(0);
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [inputOTP, setInputOTP] = useState("");

 
  const [formValues, setFormValues] = useState({
    phone_no: "",
    password: "",
    confirmPassword: ""
  });

  const selectAccountState = (state) => state.Account;
  const AccountProperties = createSelector(selectAccountState, (account) => ({
    success: account.success,
  }));

  const { success } = useSelector(AccountProperties);

  const validation = useFormik({
    initialValues: {
      phone_no: "",
      newPassword: "",
      confirmPassword: ""
    },
    validationSchema: Yup.object({
      phone_no: Yup.string()
        .required("Please Enter Your Phone Number")
        .matches(/^\d{10}$/, "Phone number must be 10 digits"),
      newPassword: Yup.string()
        .required("Please enter your password"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
        .required('Please confirm your password'),
    }),
    onSubmit: () => {
      if (phoneVerified) { 
      
      dispatch(ChangePasswordStart(formValues));
      toast.success("Password Updated Successsfully")
      navigate("/login")
    }
    else{
      toast.error('Please verify OTP');
    }
  },
  }, [formValues, phoneVerified]);

  const verifyOtpState = state => state.otpReducer
  const verifyOtpProperties = createSelector(verifyOtpState, otp => ({
    verifyOtpError: otp.verifyOtpError,
    otpVerified: otp.otpVerified,
    sendOTPLoading: otp.loading,
    otpResponseMessage: otp.otpResponseMessage,
    verifyOTPLoading: otp.verifyLoading,
  }))

  const {
    verifyOtpError,
    otpVerified,
    sendOTPLoading,
    otpResponseMessage,
    verifyOTPLoading,
  } = useSelector(verifyOtpProperties)

  useEffect(() => {
    setInputLength(validation.values.phone_no.length);
  }, [validation.values.phone_no]);

  useEffect(() => {
    dispatch(apiError(""))
    dispatch(verifyOtpErrorReset())
    dispatch(registerUserReset())
  }, [])


 
  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Change Password</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img src={logo} alt="" className="rounded-circle" height="34" />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {verifyOtpError && verifyOtpError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {verifyOtpError}
                      </Alert>
                    ) : null}
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                       
                        setFormValues({
                          phone_no: validation.values.phone_no,
                          newPassword: validation.values.newPassword,
                          confirmPassword: validation.values.confirmPassword
                        });
                        validation.handleSubmit();
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Phone Number</Label>
                        <Input
                          name="phone_no"
                          className="form-control"
                          placeholder="Enter Phone Number"
                          type="number"
                          onChange={(e) => {
                            if (!phoneVerified && e.target.value.length <= 10) {
                              validation.handleChange(e);
                            }
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.phone_no || ""}
                          invalid={
                            validation.touched.phone_no && validation.errors.phone_no ? true : false
                          }
                        
                        />
                        {validation.touched.phone_no && validation.errors.phone_no ? (
                          <FormFeedback type="invalid">{validation.errors.phone_no}</FormFeedback>
                        ) : null}
                      </div>
                      {validation.values.phone_no && (
                        <ForgetPassOtp
                          setInputOTP={setInputOTP}
                          inputOTP={inputOTP}
                          phone_no={validation.values.phone_no}
                          otpResponseMessage={otpResponseMessage}
                          verifyOTPLoading={verifyOTPLoading}
                          verifyOtpError={verifyOtpError}
                          sendOTPLoading={sendOTPLoading}
                          otpVerified={otpVerified}
                          setPhoneVerified={setPhoneVerified}
                        />
                      )}

                      <div className="mb-1">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="newPassword"
                          className="form-control"
                          type={showPass ? "text" : "password"}
                          onChange={validation.handleChange}
                          value={validation.values.newPassword}
                          invalid={!!(validation.touched.newPassword && validation.errors.newPassword)}

                        />

                        {validation.touched.newPassword && validation.errors.newPassword && (
                          <FormFeedback type="invalid">{validation.errors.newPassword}</FormFeedback>
                        )}
                      </div>
                      <div className="form-check mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customControlInline"
                            onChange={() => setShowPass(!showPass)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="customControlInline"
                          >
                            Show Password
                          </label>
                        </div>
                      <div className="mb-3">
                        <Label className="form-label">Confirm Password</Label>
                        <Input
                          name="confirmPassword"
                          className="form-control"
                          type="password"
                          onChange={validation.handleChange}
                          value={validation.values.confirmPassword}
                          invalid={!!(validation.touched.confirmPassword && validation.errors.confirmPassword)}

                        />

                        {validation.touched.confirmPassword && validation.errors.confirmPassword && (
                          <FormFeedback type="invalid">{validation.errors.confirmPassword}</FormFeedback>
                        )}
                      </div>
                      <br />
                      <div className="mt-4 ">
                        <div className="d-flex align-items-center justify-content-center">
                          <button
                            className="btn btn-primary btn-block w-50"
                            type="submit"

                          >
                            Change Password
                          </button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Go back to{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Wwings Smart Technology{" "}
                  <i className="mdi mdi-heart text-danger" />
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
